module.exports = __webpack_public_path__ + "static/ube-bar-17b5a22f2237680aaee2c46dc917010a.jpg";